import { render, staticRenderFns } from "./AppProfileNav.vue?vue&type=template&id=1b4e705c&scoped=true&"
import script from "./AppProfileNav.vue?vue&type=script&lang=js&"
export * from "./AppProfileNav.vue?vue&type=script&lang=js&"
import style0 from "./AppProfileNav.vue?vue&type=style&index=0&id=1b4e705c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4e705c",
  null
  
)

export default component.exports